export enum OrderStatusEnum {
  New = 1,
  InProgress = 2,
  TimedOut = 3,
  Completed = 4,
  WaitingForPayment = 5,
}
